export const AVISO_NOMBRE_DE_USUARIO_EN_USO = 'Ese nombre de usuario ya está en uso';
export const AVISO_FORMATO_DE_NOMBRE_DE_USUARIO =
  'El nombre de usuario solo puede contener letras, números y puntos';
